import { createFileRoute } from "@tanstack/react-router";
import { YdelserPage, ydelserHead } from "@/pages/YdelserPage";

export const Route = createFileRoute("/de/leistungen")({
  head: () => ydelserHead("de"),
  component: () => <YdelserPage locale="de" />,
});
